import React from "react"
import { useSelector } from "react-redux"


export const COLUMNS = [
  {
    Header: "Service ID",
    accessor: "mocServiceId",
  },
  {
    Header: "Service Name",
    accessor: "name",
    Cell: (row: any) => {
      return <span title={row.value}>{row.value}</span>
    },
  },

  // {
  //   Header: 'Role',
  //   accessor: 'roles',
  //   // @ts-ignore
  //   Cell: ({ cell }) => {
  //     let rolesName = cell?.value?.map((item: any) => {
  //       return item
  //     })
  //     let str = rolesName?.join(', ')

  //     return <div>{str}</div>
  //   }
  // },
  {
    Header: "Appointment Type",
    accessor: "appointmentType",
  },

  // {
  //   Header: "Service Name",
  //   accessor: "mocRate[price]",
  // },
  {
    Header: "Master Default Price",
    accessor: "masterDefaultPrice",
  },
  // {
  //   Header: "Service Owner",
  //   accessor: "owner",
  // },

  {
    Header: "",
    accessor: "edit",
    Cell: ({ cell: { } }) => (
      <img
        className="eye-icon"
        src={'assets/images/CRedit.svg'}
        width={32}
        height={30}
        style={{
          marginTop: "6px",
          paddingRight: "15px",
          width: "40px",
          height: "40px",
        }}
        alt="eye"
      />
    ),
  },
  {
    Header: "",
    accessor: "Delete",
    // @ts-ignore
    Cell: ({ cell }) => {
      // @ts-ignore
      let readOnly = useSelector((state) => state?.user?.readOnly)
      if (readOnly) return null
      else
        return (
          <img
            className="eye-icon"
            src={"assets/images/CRdelete.svg"}
            width={32}
            height={30}
            style={{
              marginTop: "6px",
              paddingRight: "15px",
              width: "40px",
              height: "40px",
            }}
            alt="eye"
          />
        )
    },
  },
]
